import React from "react";
import Layout from "@/Shared/Layout";
import Hero from "@/components/Event/EventDetail/Hero";
import MainInfo from "@/components/Event/EventDetail/MainInfo";
import Recommendation from "@/components/Event/EventDetail/Recommendation";
import AlertButton from "@/Shared/MiniComponent/AlertButton";
import { Head } from "@inertiajs/react";
import RegisButton from "@/components/Event/EventDetail/RegisButton";
import Price from "@/components/Event/EventDetail/Price";
import { dayLeft } from "@/utils/DateUtils";
import useCountDown from "@/hooks/useCountDown";

function EventDetail(props) {
    // if (props.flash.message) {
    //     alert(props.flash.message)
    // }
    
    // state for event with last registration date is h-1
    const [hours, minutes, seconds] = useCountDown(
        `${props.registration_deadline}`
    );

    const eventEnd = `${props.event.tgl_selesai} ${props.event.jam_selesai}`;

    return (
        <>
            <Head title={"Detail "+props.event.nama}/>
            <div className="container mb-5" id="client-event-detail">
                {/* Note: masih ragu apakah harus ditampilkan atau tidak */}
                {/* {props.status_fail?
                    <AlertButton
                    content={props.status_fail}
                    warningSign={true}
                    />:''
                } */}
                <Hero 
                    item={props.event} 
                    organizer={props.organizer} 
                    registration_deadline={props.registration_deadline} 
                    minmax_harga={props.minmax_harga[0]} 
                    remaining_ticket_quota={props.remaining_ticket_quota}
                    accessCode={props.access_code}
                />
                <MainInfo item={props.event} contactOrganizer={props.contactOrganizer} kapasitas={props.kapasitas} contact={props.contact} lineup={props.lineup} />
                <ButtonFixedBottom>
                    <div className="w-100">
                        <Price minmaxHarga={props.minmax_harga[0]}/>
                        <RegisButton
                            hours={hours}
                            minutes={minutes}
                            seconds={seconds}
                            isPreview={false}
                            remainingTicketQuota={props.remaining_ticket_quota}
                            slug={props.event.slug}
                            eventDay={dayLeft(eventEnd)}
                            openRegisDay={dayLeft(props.registration_deadline)}
                            accessCode={props.access_code}
                        />
                    </div>
                </ButtonFixedBottom>
            </div>
            {
                props.events.length !== 0?''
                : <Recommendation events={props.events.data} />
            }
        </>
    );
}

const ButtonFixedBottom = ({children}) => {
    return (
        <nav className="d-md-none navbar fixed-bottom bg-white shadow-lg py-3 px-2">
            <div className="container-fluid">
                {children}
            </div>
        </nav>
    )
}

EventDetail.layout = (page) => <Layout children={page}/>

export default EventDetail;